import { SubscriptionHookOptions, useQuery } from "@apollo/client";
import { GET_ACKNOWLEDGED_CONTENT } from "graphql/queries";

export function useGetAcknowledgedContent(options: SubscriptionHookOptions) {
  const { data, loading, error } = useQuery(GET_ACKNOWLEDGED_CONTENT, options);

  return { meData: data?.me || {}, loading, error };
}
